import { Alert } from "antd";
import React from "react";

function ErrorFallback({ error, resetErrorBoundary }) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div className="p-5">
      <Alert
        message="Something went wrong!"
        description={error.message}
        type="error"
        showIcon
      />
    </div>
  );
}

export default ErrorFallback;
